import { Question } from 'pages/Workshop/Transactions/TransactionCreate/components';
import { AnswersContainer } from '../../AnswersContainer';
import classNames from 'classnames';

import styles from './styles.module.scss';
import { ButtonsContainer } from '../../ButtonsContainer';
import { Continue } from '../../Continue';
import { Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { transactionPreFormQuestionsIds } from 'settings/constants/transaction';
import { setTransactionPreFormQuestionsEffect } from 'store/effects';
import { getTransactionPreFormSelector } from 'store/selectors/transactions';
import { getTransactionSelector } from 'store/selectors/transaction';
import Icons from 'components/Transactions/Icons';

export const ShowingLinkConfirmation = (props) => {
  const { className, setStage, nextJumpingStage } = props;

  const { transaction } = useSelector(getTransactionSelector);
  const { preForm } = useSelector(getTransactionPreFormSelector);
  const dispatch = useDispatch();

  const { showingLinkConfirmation: showingConfirmation } = transactionPreFormQuestionsIds;

  const showingLinkConfirmation = props.showingLinkQuestion || showingConfirmation;

  const shouldDisableLink = !!preForm[showingLinkConfirmation]?.disableShowingLink;

  if (!transaction) return null;

  const makeLinkDisable = (shouldDisable) => {
    dispatch(
      setTransactionPreFormQuestionsEffect({
        [showingLinkConfirmation]: {
          disableShowingLink: shouldDisable,
        },
      }),
    );
  };

  const onNextHandler = () => {
    setStage(nextJumpingStage);
  };

  const onViewLink = () => {
    window.open(transaction.Showing.ShowingLink, '_blank');
  };

  return (
    <div
      testid="what_purchase_prise"
      className={classNames(
        styles.presenting,
        styles.container,
        styles.showingLinkConfirmation,
        className,
      )}
    >
      <Question>
        The showing submission link for this listing is still active. Do you want to deactivate it?
      </Question>
      <AnswersContainer>
        <Button
          type="text"
          className={classNames(styles.answerBtn, {
            [styles.active]: shouldDisableLink,
          })}
          onClick={() => makeLinkDisable(true)}
        >
          Yes
        </Button>

        <Button
          type="text"
          className={classNames(styles.answerBtn, {
            [styles.active]: !shouldDisableLink,
          })}
          onClick={() => makeLinkDisable(false)}
        >
          No, keep it open
        </Button>

        <div className={styles.viewLink} onClick={onViewLink}>
          <div className={styles.viewLinkText}>View Link</div>
          <Icons variant="external" className={styles.icon} />
        </div>
      </AnswersContainer>
      <ButtonsContainer>
        <Continue onClick={onNextHandler} />
      </ButtonsContainer>
    </div>
  );
};
